import api from './api';
import { AxiosInstance } from 'axios';
import { BasicResponse, InitPaymentResponse, PaymentDetailsResponse, InitiatePaymentRequest, FetchAllPaymentsQueryParams } from '../types/api';

const paymentService = {
  verifyPaymentToken: async (): Promise<BasicResponse<string>> => {
    try {
      const response = await (api as AxiosInstance).get('/api/Payment/verifyToken');
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  },

  initiatePayment: async (paymentRequest: InitiatePaymentRequest): Promise<InitPaymentResponse> => {
    try {
      const response = await (api as AxiosInstance).post("/payments/init", paymentRequest);
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  },

  getPaymentDetails: async (payment_id: string): Promise<PaymentDetailsResponse> => {
    try {
      const response = await (api as AxiosInstance).get(`/payments/${payment_id}`);
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  },

  fetchAllPayments: async (params?: FetchAllPaymentsQueryParams): Promise<PaymentDetailsResponse[]> => {
    try {
      const response = await (api as AxiosInstance).get('/payments', { params });
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  }
};

export default paymentService;
